<p-menubar #navbar [model]="items">
    <p-button [label]="addNewEntityButtonLabel" icon="pi pi-plus" iconPos="right" (click)="addNewEntity($event)"></p-button>
</p-menubar>
